import { PossibleActions } from './admin.interface';
import { UserInfo } from "./user.interface";
import { Customer } from "./customer.interface";
import {Specifications} from "./specifications.interface";

export enum ProjectActions {
  NEW_PROJECT = "NEW_PROJECT",
  EDIT_PROJECT = "EDIT_PROJECT",
  OPEN_PROJECT = "OPEN_PROJECT",
  EDIT_ACTIVITY = "EDIT_ACTIVITY",
  DISASSOCIATE_USER = "DISASSOCIATE_USER",
  GENERATE_CONSTRUCTION = "GENERATE_CONSTRUCTION",
  ADD_EXTERNAL_ARCHIVE = "ADD_EXTERNAL_ARCHIVE",
  EDIT_EXTERNAL_ARCHIVE = "EDIT_EXTERNAL_ARCHIVE",
  DELETE_EXTERNAL_ARCHIVE = "DELETE_EXTERNAL_ARCHIVE",
}

export enum ProjectAnalysisSection {
  INFORMATION = "INFORMATION",
  WORKFLOW = "WORKFLOW",
  ASSOCIATED_USERS = "ASSOCIATED_USERS",
  DOCUMENTS = "DOCUMENTS",
  REMINDER = "REMINDER",
  SAFETY = "SAFETY",
}

export enum ProjectState {
  OPEN = 0,
  CLOSED = 1,
  FORCED = 2,
}

export enum DocumentState {
  ALL = null,
  LOADED = 1,
  NOT_LOADED = 0,
}

export enum DocumentType {
  WORKFLOW_DOCS = "WORKFLOW_DOCS",
  SAFETY_DOCS = "SAFETY_DOCS",
}

export interface ProjectInfo {
  id?: number;
  name?: string;
  description?: string;
  startDate?: number;
  projectTypeName?: string;
  headquarterName?: string;
  company?: number;
  workflowName?: string;
  customerType?: string;
  idActualPhase?: number;
  actualPhaseName?: string;
  percentageProgress?: number;
  numTotActivity?: number;
  numCompletedActivity?: number;
  elapsedProjectDays?: number;
  elapsedLastActivityDays?: number;
  isConstruction?: boolean;
  specificationsType?: boolean;
  validSpecifications?: boolean;
  specifications?: Specifications;
  projectState?: number;
  hasExpiredReminders?: boolean;
  customer?: Customer;
  possibleAction?: PossibleActions;
}

export interface Project {
  id?: number;
  name?: string;
  type?: string;
  idWorkflow?: number;
  idCategory?: number;
  startDate?: number;
  idHeadquarter?: number;
  description?: string;
  customer?: Customer;
  company?: number;
}

export interface ProjectInformation {
  id?: number;
  idWorkflow?: number;
  idHeadquarter?: number;
  userOwner?: UserInfo;
  name?: string;
  description?: string;
  workflowName?: string;
  headquarterName?: string;
  projectTypeName?: string;
  customerType?: string;
  projectState?: number;
  customer?: Customer;
  possibleAction?: PossibleActions; 
  startDate?: number;
  tsCreated?: number;
}

export interface ExternalArchive {
  description?: string;
  id?: number;
  name?: string;
  tsCreated?: number;
  url?: string;
}
